import React, { useState } from 'react';


import { ActivitySectionLayout } from 'modules/components/layer32';
import { SuperAdminTable } from 'modules/components/layer25';

export type UsersDetailSectionProps = {};

export const FC = (props: UsersDetailSectionProps) => {

  return (
    <ActivitySectionLayout.FC>
      <SuperAdminTable.FC />
    </ActivitySectionLayout.FC>

  );
};
